import { apiGet, apiPost, apiDelete } from '../../api/index';
import { urlPeriodos } from '../../api/urls';

export function filter(params) {
  const pageInfo = params && params.pageInfo
    ? params.pageInfo
    : { page: 1, pageSize: 15 };
  return apiPost(`${urlPeriodos}/all`, pageInfo)
    .then((res) => {
      if (res.error) {
        throw (res.error);
      }
      if (params && params.onSuccess) params.onSuccess(res);
      return res;
    })
    .catch((error) => {
      if (params && params.onError) params.onError(error);
    });
}

export function get(id, callback) {
  return apiGet(`${urlPeriodos}/${id}`)
    .then((res) => {
      if (res.error) {
        throw (res.error);
      }
      if (callback && callback.onSuccess) callback.onSuccess(res);
      return res;
    })
    .catch((error) => {
      if (callback && callback.onError) callback.onError(error);
    });
}

export function save(obj, callback) {
  return apiPost(`${urlPeriodos}`, obj)
    .then((res) => {
      if (res.error) {
        throw (res.error);
      }
      if (callback && callback.onSuccess) callback.onSuccess(res);
      return res;
    })
    .catch((error) => {
      if (callback && callback.onError) callback.onError(error);
    });
}

export function remove(id, callback) {
  return apiDelete(`${urlPeriodos}/${id}`)
    .then((res) => {
      if (res.error) {
        throw (res.error);
      }
      if (callback && callback.onSuccess) callback.onSuccess(res);
      return res;
    })
    .catch((error) => {
      if (callback && callback.onError) callback.onError(error);
    });
}

export function fetchFormDatas(params) {
  return apiGet(`${urlPeriodos}/form_data`)
    .then((res) => {
      if (res.error) {
        throw (res.error);
      }
      if (params && params.onSuccess) params.onSuccess(res);
      return res;
    })
    .catch((error) => {
      if (params && params.onError) params.onError(error);
    });
}

export function fetchEditSubjectsFormData(periodoId, params) {
  return apiGet(`${urlPeriodos}/form_data_edit_subjects/${periodoId}`)
    .then((res) => {
      if (res.error) {
        throw (res.error);
      }
      if (params && params.onSuccess) params.onSuccess(res);
      return res;
    })
    .catch((error) => {
      if (params && params.onError) params.onError(error);
    });
}


export function fetchAllSubjectsBySemesters(params) {
  return apiGet(`${urlPeriodos}/subjects_by_semesters/${params.periodoId}/${params.carreraId}`)
    .then((res) => {
      if (res.error) {
        throw (res.error);
      }
      if (params && params.onSuccess) params.onSuccess(res);
      return res;
    })
    .catch((error) => {
      if (params && params.onError) params.onError(error);
    });
}

export function saveSubjects(data, callback) {
  return apiPost(`${urlPeriodos}/save_subjects`, data)
    .then((res) => {
      if (res.error) {
        throw (res.error);
      }
      if (callback && callback.onSuccess) callback.onSuccess(res);
      return res;
    })
    .catch((error) => {
      if (callback && callback.onError) callback.onError(error);
    });
}
